import {
  CREATE_CUSTOMER,
  EDIT_CUSTOMER,
  RECEIVE_CUSTOMER,
  RECEIVE_CUSTOMERS,
  REQUEST_ALL_CUSTOMERS,
  REQUEST_CUSTOMER,
} from '@sophocles/entities/Customer/customerActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CUSTOMERS:
      return state.mergeDeep(action.customers);
    case RECEIVE_CUSTOMER:
      return state.mergeDeep(action.customer);
    case REQUEST_CUSTOMER:
    case REQUEST_ALL_CUSTOMERS:
    case EDIT_CUSTOMER:
    case CREATE_CUSTOMER:
    default:
      return state;
  }
}

export function customerReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_CUSTOMERS:
    case RECEIVE_CUSTOMER:
    case REQUEST_CUSTOMER:
    case REQUEST_ALL_CUSTOMERS:
    case EDIT_CUSTOMER:
    case CREATE_CUSTOMER:
      return getState(state, action);
    default:
      return state;
  }
}
